var paragraph_default = {
  "fontElementMap": "UedLc",
  "elementSpacing": "_6cuve",
  "text": "dSoN4 _6cuve",
  "child": "-buxx"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
